import React, {useState, useRef, useEffect} from 'react'
import styled from 'styled-components'
import {_L, useLocaleState} from '../../context/LocaleContext'

const Camera = ({selectedDevice, onCancel, onSaveData}) => {
  const localeState = useLocaleState()
  const videoRef = useRef(null)
  const canvasRef = useRef(null)
  const stream = useRef(null)
  const [isAcquiringPhoto, setIsAcquiringPhoto] = useState(true)
  const [isCameraLoaded, setIsCameraLoaded] = useState(false)

  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({
        video: {
          deviceId: {exact: selectedDevice}
        }
      })
      .then(mediaStream => {
        stream.current = mediaStream
        videoRef.current.srcObject = mediaStream
        setIsCameraLoaded(true)
      })
      .catch(error => {
        alert(error)
        console.log(error)
        onCancel()
      })
  }, [])

  const onCapture = () => {
    let video = videoRef.current
    let canvas = canvasRef.current

    // TODO: Change canvas size to match the container size.

    canvas.width = video.videoWidth
    canvas.height = video.videoHeight

    canvas.getContext('2d').drawImage(video, 0, 0)

    setIsAcquiringPhoto(false)
  }

  const doCancel = () => {
    if (stream && stream.current) {
      let tracks = stream.current.getTracks()
      tracks.forEach(track => track.stop())
    }

    onCancel()
  }

  const doSaveData = () => {
    let canvas = canvasRef.current
    let data = canvas.toDataURL()

    onSaveData(data)
  }

  return (
    <Container isCameraLoaded={isCameraLoaded}>
      <VideoContainer isAcquiringPhoto={isAcquiringPhoto}>
        <StyledVideo ref={videoRef} autoPlay />
        <ButtonContainer>
          <LeftButton onClick={doCancel}>
            {_L({key: 'Cancel', localeState})}
          </LeftButton>
          <RightButton onClick={onCapture}>
            {_L({key: 'Capture', localeState})}
          </RightButton>
        </ButtonContainer>
      </VideoContainer>

      <CanvasContainer>
        <StyledCanvas ref={canvasRef} />
        <ButtonContainer>
          <LeftButton onClick={doCancel}>
            {_L({key: 'Cancel', localeState})}
          </LeftButton>
          <RightButton onClick={doSaveData}>
            {_L({key: 'Use Image', localeState})}
          </RightButton>
        </ButtonContainer>
      </CanvasContainer>
    </Container>
  )
}

export default Camera

const Container = styled.div`
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 20px;
  display: ${props => (props.isCameraLoaded ? 'block;' : 'none;')};
  flex: 1;
`

const VideoContainer = styled.div`
  display: ${props => (props.isAcquiringPhoto ? 'flex;' : 'none;')};
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;
  justify-content: center;
  align-items: center;
`

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  justify-content: center;
  align-items: center;
  height: 100px;
`

const StyledButton = styled.button`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  color: #ffffff;
  flex: 1;
  height: 40px;
  border-radius: 6px;
  min-width: 80px;
  max-width: 160px;
  background: #3395fe;
  border: 1px solid #3395fe;
  margin: 4px;
`

const LeftButton = styled(StyledButton)`
  margin-right: 20px;
`

const RightButton = styled(StyledButton)`
  margin-left: 20px;
`

const CanvasContainer = styled.div`
  display: ${props => (props.isAcquiringPhoto ? 'none;' : 'flex;')}
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  align-content: space-between;
  flex: 1;
`

const StyledVideo = styled.video`
  width: 70vw;
  height: 70vw;
`

const StyledCanvas = styled.canvas`
  width: 100%;
  height: 100%;
  flex: 1;

  @media (min-width: 768px) {
    width: 50vw;
  }
`
